
<div class="container">
    <div class="d-flex row justify-content-end">
        <div class="col-md-6">
            <div class="outer">
                <div class="pane">
                    <div class="my-3">
                        <label>Email Address</label>
                        <input type="email" class="input input-round"
                             [(ngModel)]="email"  placeholder="email@binst.com"/>
                    </div>
                    <div class="my-3 ">
                        <label class="">Display name</label>
                        <input type="text" class="input input-round"
                               [(ngModel)]="displayName" placeholder="your_name_here"/>
                    </div>
                    <div class="my-3">
                        <label class="">Password</label>
                        <input type="password" class="input input-round"
                               [(ngModel)]="password" placeholder="password"/>
                    </div>
                    <div class="my-3">
                        <input type="password" class="input input-round"
                               [(ngModel)]="confirmPassword" placeholder="confirm password"/>
                    </div>
                    <div *ngIf="error" class="alert alert-danger">{{error}}</div>

                    <div class="d-flex w-100 justify-content-between mt-3">
                        <a href="/auth/enter" class="btn button pointer" >Login</a>
                        <div class="btn button pointer" (click)="register()">Sign up!</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-6"></div>
    </div>
</div>
